import { createContext } from "react";

import { SettingsContextProps } from "../data/types";

export const SettingsContext = createContext<SettingsContextProps>({
  origins: [],
  salesLostReasons: [],
  rejectReasons: [],
  notesTypes: [],
  companyPositions: [],
  stdFolders: [],
  disabledSuppliers: [],
  afterSalesServices: [],
  autoPricingType: "SIMPLE",
  autoPricingCalc: "GROSS_MARGIN",
  autoPricing: [],
  autoPricingDetailed: {
    autoPricingCalc: "GROSS_MARGIN",
    restrictions: [],
    pricingComponents: [],
  },
  addons: [] as SettingsContextProps["addons"],
  autoFinancing: { banks: [] },
  preferences: {} as SettingsContextProps["preferences"],
  permissions: {} as SettingsContextProps["permissions"],
  individualPermissions: [] as SettingsContextProps["individualPermissions"],
  teams: [] as SettingsContextProps["teams"],
  suppliers: {} as SettingsContextProps["suppliers"],
  webhooks: [] as SettingsContextProps["webhooks"],
  wppAccounts: [] as SettingsContextProps["wppAccounts"],
  proposalSlug: "",
  updateAutoPricingTypeHandler: (newType) => {},
  updateAutoPricingCalcHandler: (newCalc) => {},
  updateOriginsHandler: (newOrigins) => {},
  updateSalesLostReasonsHandler: (newReasons) => {},
  updateRejectReasonsHandler: (newReasons) => {},
  updateCompanyPositionsHandler: (newPositions) => {},
  updateStdFoldersHandler: (newFolders) => {},
  updateDisabledSuppliersHandler: (suppliers) => {},
  updateAfterSalesServicesHandler: (services) => {},
  updateNotesTypesHandler: (newTypes) => {},
  updateAutoPricingHandler: (newAutoPricing) => {},
  updateAutoPricingDetailedHandler: (newAutoPricingDetailed) => {},
  updateAutoFinancingHandler: (newAutoFinancing) => {},
  updatePreferencesHandler: (newPreferences) => {},
  updatePermissionsHandler: (newPermissions) => {},
  updateIndividualPermissionsHandler: (newPermissions) => {},
  updateTeamsHandler: (newTeams) => {},
  updateSuppliersHandler: (newSuppliers) => {},
  updateProposalSlugHandler: (newSlug) => {},
  updateWebhooksHandler: (newWebhooks) => {},
  updateWppAccountsHandler: (newWppAccounts) => {},
  updateAddonsHandler: (newAddons) => {},
});
